import { DEMOTE_USER_BY_ID } from "../api-services/ApiEndpoints";

export const demoteUserToUser = async (userId) => {
    const url = `${process.env.REACT_APP_API_URL}${DEMOTE_USER_BY_ID.replace('{id}', userId)}`;
    const token = localStorage.getItem('token');
    
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'accept': 'application/json'
        }
    });
    
    if (!response.ok) {
        throw new Error(`Failed to demote user: ${response.status}`);
    }
    
    return await response.json();
};